/**
 * @summary The Default Header For the Landing Pages.
 */
import React, { forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'utils/classnames';
import Wysiwyg from 'components/blocks/wysiwyg/Wysiwyg';
import CtaButton from 'components/blocks/ctaButton/CtaButton';
import { CtaPropTypes } from 'utils/propTypes';
import { TMS_EVENT_TYPES } from 'utils/analytics/EVENT_TYPES';
import ToolTip from 'components/base/toolTip/ToolTip';
import Logo from 'components/base/logo/Logo';
import GlobalContext from 'hooks/contexts/GlobalContext';

function DefaultLandingHeader({
  cta,
  headertext,
  siteName,
  className = 'header--landingPage',
  innerRef,
  logoLink,
}) {
  const headerClass = cx({
    header: true,
    'header--hasHeaderText': !!headertext,
    [className]: true,
  });

  const {
    siteMeta: { disclosure },
  } = useContext(GlobalContext);

  return (
    <header className={headerClass} ref={innerRef}>
      <div className="header__inner">
        <Logo siteName={siteName} logoLink={logoLink} />
        {headertext && (
          <div className="header__secondary">
            <Wysiwyg content={headertext} />
          </div>
        )}
        {cta && cta.useCTA && (
          <div className="header__secondary">
            <CtaButton
              buttonText={cta.buttonText}
              buttonActionType={cta.buttonActionType}
              link={cta.link}
              trackingLabel={TMS_EVENT_TYPES.Header}
            />
          </div>
        )}
        {disclosure && (
          <div className="header__disclosure">
            <ToolTip label="Advertiser Disclosure" positioning="bottom">
              <Wysiwyg isClean content={disclosure} />
            </ToolTip>
          </div>
        )}
      </div>
    </header>
  );
}

DefaultLandingHeader.propTypes = {
  headertext: PropTypes.string,
  className: PropTypes.string,
  cta: CtaPropTypes,
  siteName: PropTypes.string,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  logoLink: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    target: PropTypes.string,
  }),
};

// export default forwardRef(DefaultLandingHeader);

const ForwardedDefaultLandingHeader = forwardRef((props, ref) => {
  const { cta, headertext, siteName, className, logoLink } = props;
  return (
    <DefaultLandingHeader
      cta={cta}
      headertext={headertext}
      siteName={siteName}
      className={className}
      logoLink={logoLink}
      innerRef={ref}
    />
  );
});

ForwardedDefaultLandingHeader.displayName = 'DefaultLandingHeader';

export default ForwardedDefaultLandingHeader;
